import { render, staticRenderFns } from "./TransferGuide.vue?vue&type=template&id=0cbe6a92&scoped=true&"
import script from "./TransferGuide.vue?vue&type=script&lang=ts&"
export * from "./TransferGuide.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGuide.vue?vue&type=style&index=0&id=0cbe6a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe6a92",
  null
  
)

export default component.exports